module.exports = __webpack_public_path__ + "static/service-tek-55d7850efbb1d616cceadd77ff2ebba5.png";